import { Monitor, Package, Wrench } from 'lucide-react';

export const PRODUCT_TYPES = {
  DIGITAL: 'digital',
  PHYSICAL: 'fisico',
  SERVICE: 'servico'
} as const;

export const productTypeConfig = {
  [PRODUCT_TYPES.DIGITAL]: {
    id: PRODUCT_TYPES.DIGITAL,
    name: 'Produto Digital',
    icon: Monitor,
    badgeColor: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    futureTabs: ['visao_geral', 'roadmap', 'releases', 'equipe', 'clientes', 'financeiro', 'arquivos', 'pulse', 'historico', 'ia']
  },
  [PRODUCT_TYPES.PHYSICAL]: {
    id: PRODUCT_TYPES.PHYSICAL,
    name: 'Produto Físico',
    icon: Package,
    badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    futureTabs: ['visao_geral', 'estoque', 'compras', 'fornecedores', 'financeiro', 'arquivos', 'pulse', 'historico', 'ia']
  },
  [PRODUCT_TYPES.SERVICE]: {
    id: PRODUCT_TYPES.SERVICE,
    name: 'Serviço',
    icon: Wrench,
    badgeColor: 'bg-orange-50 text-orange-700 border-orange-200',
    futureTabs: ['visao_geral', 'agenda', 'equipe', 'clientes', 'contratos', 'financeiro', 'pulse', 'historico', 'ia']
  }
};
